import { adminRoute } from 'shared/routes/AllRoutes';
import { store } from 'shared/redux/Store';
import { setRestrictScreen } from 'shared/redux/reducers/restrictScreenSlice';
import { adminEnum, screenActionEnum } from './Enum';

const classNames = require('classnames');
const checkActivePath = (path) => {
    // let isExistIndex = adminRoute.findIndex((ii) => ii.path === path);
    let isExistIndex = adminRoute.findIndex((ii) => ii.path === path);
    if (isExistIndex > -1) {
        return true;
    } else {
        return false;
    }
};
const isNumberCheck = (e) => {
    e = e || window.event;
    var charCode = e.which ? e.which : e.keyCode;
    return /\d/.test(String.fromCharCode(charCode));
};
const calculatePixels = (value) => {
    const screenWidth = window.innerWidth;
    const ratio = screenWidth / 1920;
    const result = value * ratio;
    return result;
};
const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
        return text; // No need to truncate
    }

    // If the text is longer than maxLength, truncate it and add '...' at the end
    return text.substring(0, maxLength - 3) + '...';
};
const nFormatter = (num) => {
    const lookup = [
        { value: 1, symbol: '' },
        { value: 1e3, symbol: 'k' },
        { value: 1e6, symbol: 'M' },
        { value: 1e9, symbol: 'G' },
        { value: 1e12, symbol: 'T' },
        { value: 1e15, symbol: 'P' },
        { value: 1e18, symbol: 'E' }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
        .slice()
        .reverse()
        .find(function (item) {
            return num >= item.value;
        });
    return item ? (num / item.value).toFixed(1).replace(rx, '$1') + item.symbol : '0';
};
const isRestricted = (screen) => {
    const { routePermission, user } = store.getState();
    const userRole = user?.user?.role;
    if (userRole?.name === adminEnum.superAdmin) {
        return true;
    } else {
        if (!routePermission.RoutelistPath.includes(screen)) {
            store.dispatch(setRestrictScreen({ restrictScreen: true }));
        } else {
            return true;
        }
    }
};
const isRestrictActions = (screen, actionType) => {
    const { routePermission, user } = store.getState().root;
    const userRole = user?.user?.role;
    let arr = [];
    Object.entries(userRole).forEach(([key, value]) => {
        let propertyKey = key;
        if (routePermission.RoutelistPath.includes(propertyKey)) {
            let screenObj = {
                screen: propertyKey,
                ...value
            };
            arr.push(screenObj);
        }
    });
    let findAccessAction = arr.find((ii) => ii.screen === screen);
    switch (actionType) {
        case screenActionEnum.create:
            if (userRole?.name === adminEnum.superAdmin) {
                return true;
            } else {
                if (findAccessAction?.create) {
                    return true;
                } else {
                    store.dispatch(setRestrictScreen({ restrictScreen: true }));
                }
            }
            break;
        case screenActionEnum.update:
            if (userRole?.name === adminEnum.superAdmin) {
                return true;
            } else {
                if (findAccessAction?.update) {
                    return true;
                } else {
                    store.dispatch(setRestrictScreen({ restrictScreen: true }));
                }
            }
            break;
        case screenActionEnum.delete:
            if (userRole?.name === adminEnum.superAdmin) {
                return true;
            } else {
                if (findAccessAction?.delete) {
                    return true;
                } else {
                    store.dispatch(setRestrictScreen({ restrictScreen: true }));
                }
            }
            break;
        default:
            store.dispatch(setRestrictScreen({ restrictScreen: true }));
            return false;
    }
};
const deepCopy = (obj) => {

    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    if (Array.isArray(obj)) {
        const copyArray = [];
        for (let i = 0; i < obj.length; i++) {
            copyArray[i] = deepCopy(obj[i]);
        }
        return copyArray;
    }

    const copyObject = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            copyObject[key] = deepCopy(obj[key]);
        }
    }

    return copyObject;
};
const fomatTextCapitalize = (text) => {
    return (
        text &&
        text
            .split(' ')
            .map((txt) => {
                txt = txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
                return txt;
            })
            .join(' ')
    );
};
const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'];
const checkFileType = (filetype) => {
    if (SUPPORTED_FORMATS.includes(filetype)) {
        return true;
    } else {
        return false;
    }
};
const calculateDifferenceInHours = (date1, date2) => {
    const diffInMilliseconds = date2 - date1;
    const diffInSeconds = diffInMilliseconds / 1000;
    return diffInSeconds;
};
const hasActionPermission = (screen, actionType) => {
    const { routePermission, user } = store.getState().root;
    const userRole = user?.user?.role;
    if (userRole?.name === adminEnum.superAdmin) {
        return true;
    }
    let arr = [];
    Object.entries(userRole || {}).forEach(([key, value]) => {
        let propertyKey = key;
        if (routePermission.RoutelistPath.includes(propertyKey)) {
            let screenObj = {
                screen: propertyKey,
                ...value
            };
            arr.push(screenObj);
        }
    });
    let findAccessAction = arr.find((ii) => ii.screen === screen);
    if (!findAccessAction) return false;
    
    switch (actionType) {
        case screenActionEnum.create:
            return !!findAccessAction.create;
        case screenActionEnum.update:
            return !!findAccessAction.update;
        case screenActionEnum.delete:
            return !!findAccessAction.delete;
        default:
            return false;
    }
};

export {
    classNames,
    checkActivePath,
    calculatePixels,
    truncateText,
    isNumberCheck,
    nFormatter,
    deepCopy,
    fomatTextCapitalize,
    isRestricted,
    isRestrictActions,
    hasActionPermission,
    checkFileType,
    calculateDifferenceInHours
};
